<template>
<v-container fluid>
  <v-card>
    <v-card-title primary-title style="padding-left: 8px; padding-bottom: 8px">
      <span class="headline mb-0">操作监控</span>
    </v-card-title>
    <v-card-actions>
      <v-btn @click="search" class="btn-search">search</v-btn>
      <v-btn @click="eiajDrsumSendByDay" v-if="true" v-permit.SHARP_FU_ARCHIVE_MONTHLY_AR_DOWNLOAD>AR DR.SUM_IF速報(按天)</v-btn>
      <v-btn @click="eiajDrsumSendByMonth" v-if="true" v-permit.SHARP_FU_ARCHIVE_MONTHLY_AR_DOWNLOAD>AR DR.SUM_IF速報(按月)</v-btn>
      <v-btn @click="apDrsumSend" v-if="true" v-permit.SHARP_FU_ARCHIVE_MONTHLY_AR_DOWNLOAD>AP DR.SUM_IF財務実績(按月)</v-btn>
      <v-btn @click="exchangeCalendarType()" v-if="true">交换稼动年月类型</v-btn>
      <v-btn @click="updateErrorReservationStatus()" v-if="true">更新错误的预约状态数据</v-btn>

      <!-- <v-btn
          @click="threeMonthAverageGenerate"
          v-if="true"
          v-permit.SHARP_FU_ARCHIVE_MONTHLY_AR_DOWNLOAD
          >三个月平均诸挂归档</v-btn
        > -->

      <v-flex md2 pl-2 sm2 xs2>
        <date-picker label="冻结日期" v-model="query.yearMonth"></date-picker>
      </v-flex>
    </v-card-actions>
  </v-card>
  <v-card class="mt-2">
    <v-form>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs3>
            <v-text-field clearable label="BlNo" v-model="query.blNo" />
          </v-flex>
          <v-flex xs3>
            <v-text-field clearable label="InvoiceNo" v-model="query.invoiceNo" />
          </v-flex>
          <v-flex xs3>
            <v-text-field clearable label="DoNo" v-model="query.doNo" />
          </v-flex>
          <v-flex xs3>
            <v-text-field clearable label="operatorName" v-model="query.operatorName" />
          </v-flex>
          <v-flex xs3>
            <v-text-field clearable label="Status" v-model="query.status" />
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
  <v-card>
    <v-data-table :headers="headers" :items="results" :loading="loading" :pagination.sync="pagination" :rows-per-page-items="[10, 20, 50, 100, 200, 500, 1000]" :total-items="pagination.totalItems" item-key="id" select-all v-model="selected[pagination.page]">
      <template slot="items" slot-scope="props">
        <td>
          <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
        </td>
        <td>{{ props.item.shipmentType }}</td>
        <td>{{ props.item.blNo }}</td>
        <td>{{ props.item.branchCode }}</td>
        <td>{{ props.item.doNo }}</td>
        <td>{{ props.item.invoiceNo }}</td>
        <td>{{ props.item.containerNos }}</td>
        <td>{{ props.item.operationDate }}</td>
        <td>{{ props.item.operatorName }}</td>
        <td>{{ props.item.status }}</td>
      </template>
    </v-data-table>
  </v-card>
</v-container>
</template>

<script>
export default {
  data() {
    return {
      selected: [],
      results: [],
      pagination: {
        rowsPerPage: 10,
      },
      loading: false,
      query: {
        yearMonth: ''
      },
      headers: [{
          text: 'shipmentType',
          value: 'shipmentType',
          sortable: false,
        },
        {
          text: 'BlNo',
          value: 'blNo',
          sortable: false,
        },
        {
          text: 'branchCode',
          value: 'branchCode',
          sortable: false,
        },
        {
          text: 'DoNo',
          value: 'doNo',
          sortable: false,
        },
        {
          text: 'InvoiceNo',
          value: 'invoiceNo',
          sortable: false,
        },
        {
          text: 'ContainerNos',
          value: 'ContainerNos',
          sortable: false,
        },
        {
          text: 'OperationDate',
          value: 'operationDate',
          sortable: false,
        },
        {
          text: 'OperatorName',
          value: 'operatorName',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    exchangeCalendarType() {
      this.$http.get(`updates/exchange-calendar`).then(res => {
        this.$message('', res.data)
      })
    },
    updateErrorReservationStatus() {
      this.$http.get(`updates/error-reservation-status`).then(res => {
        this.$message('', res.data)
      })
    },
    eiajDrsumSendByDay() {
      this.drsumSend('arap/b2b/ar/eiajs/by-day')
    },
    eiajDrsumSendByMonth() {
      this.drsumSend('arap/b2b/ar/eiajs/by-month')
    },
    apDrsumSend() {
      this.drsumSend('arap/b2b/ap/drsum')
    },
    drsumSend(path) {
      this.$http.post(`${path}?yearMonth=${this.query.yearMonth}`).then(() => {
        this.$message('', 'success!')
      })
    },
    threeMonthAverageGenerate() {
      this.$http
        .post(`charge-job?yearMonth=${this.query.yearMonth}`)
        .then(() => {
          this.$message('', 'charge job success!')
        })
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
          sort: 'operationDate,desc',
        },
      }
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http.get('/operations', this.params()).then((res) => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
    resetStatus(id) {
      this.$http
        .put(`mail/reset-status/${id}`)
        .then(() => {
          this.$message('', '重置成功')
        })
        .catch(() => {
          this.$message('', '重置失败')
        })
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
}
</script>
